import React from "react";
import { useTranslation } from "react-i18next";
import { Label, Input } from "reactstrap";
import { Controller } from "react-hook-form";
import { parseCodAmount, COD_AMOUNT_RULE } from "../../utils/codAmount";

// `cod` = { enabled, currency } tal como lo informa el operador vía BFF. El campo de
// monto sólo existe si el operador cobra contra entrega; sin ese dato no se ofrece.
export default function PackageDetailsStep({ methods, cod }) {
  const { control } = methods;
  const { t } = useTranslation();
  const codEnabled = !!cod?.enabled;

  return (
    <div className="package-details-step">
      <div className="package-details-step__header">
        <h4>{t("Información del paquete")}</h4>
        <p>{t("Estos datos son opcionales")}</p>
      </div>
      
      <div className="package-details-step__form">
        <div className="package-details-step__row package-details-step__row--first">
          <Label htmlFor="order_id" className="package-details-step__label">{t("Número de venta")}</Label>
          <Controller
            name="order_id"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <Input 
                  {...field} 
                  id="order_id"
                  placeholder={t("Ej: ORD-2024-001")}
                  invalid={!!fieldState.error}
                  className="package-details-step__input"
                />
                {fieldState.error && (
                  <small className="text-danger d-block mt-1">{fieldState.error.message}</small>
                )}
              </>
            )}
          />
        </div>

        <div className="package-details-step__row package-details-step__row--dimensions">
          <div className="package-details-step__field">
            <Label className="package-details-step__label">{t("Peso (kg)")}</Label>
            <Controller
              name="package_weight"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <Input 
                    {...field} 
                    type="number" 
                    placeholder="1.5" 
                    step="0.1" 
                    invalid={!!fieldState.error}
                    className="package-details-step__input"
                  />
                  {fieldState.error && (
                    <small className="text-danger d-block mt-1">{fieldState.error.message}</small>
                  )}
                </>
              )}
            />
          </div>
          <div className="package-details-step__field">
            <Label className="package-details-step__label package-details-step__label--muted">{t("Largo (cm)")}</Label>
            <Controller
              name="package_length"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <Input 
                    {...field} 
                    type="number" 
                    placeholder="30" 
                    step="0.1" 
                    invalid={!!fieldState.error}
                    className="package-details-step__input"
                  />
                  {fieldState.error && (
                    <small className="text-danger d-block mt-1">{fieldState.error.message}</small>
                  )}
                </>
              )}
            />
          </div>
          <div className="package-details-step__field">
            <Label className="package-details-step__label package-details-step__label--muted">{t("Ancho (cm)")}</Label>
            <Controller
              name="package_width"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <Input 
                    {...field} 
                    type="number" 
                    placeholder="20" 
                    step="0.1" 
                    invalid={!!fieldState.error}
                    className="package-details-step__input"
                  />
                  {fieldState.error && (
                    <small className="text-danger d-block mt-1">{fieldState.error.message}</small>
                  )}
                </>
              )}
            />
          </div>
          <div className="package-details-step__field">
            <Label className="package-details-step__label package-details-step__label--muted">{t("Alto (cm)")}</Label>
            <Controller
              name="package_height"
              control={control}
              render={({ field, fieldState }) => (
                <>
                  <Input 
                    {...field} 
                    type="number" 
                    placeholder="15" 
                    step="0.1" 
                    invalid={!!fieldState.error}
                    className="package-details-step__input"
                  />
                  {fieldState.error && (
                    <small className="text-danger d-block mt-1">{fieldState.error.message}</small>
                  )}
                </>
              )}
            />
          </div>
        </div>

        {codEnabled && (
          <div className="package-details-step__row">
            <Label htmlFor="cod_amount" className="package-details-step__label">
              {t("Monto a cobrar")}{cod?.currency ? ` (${cod.currency})` : ""}
            </Label>
            <Controller
              name="cod_amount"
              control={control}
              rules={{
                validate: (value) =>
                  parseCodAmount(value).status === "invalid"
                    ? t(COD_AMOUNT_RULE)
                    : true,
              }}
              render={({ field, fieldState }) => (
                <>
                  <Input
                    {...field}
                    id="cod_amount"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder={t("Ej: 19990")}
                    invalid={!!fieldState.error}
                    className="package-details-step__input"
                  />
                  {fieldState.error && (
                    <small className="text-danger d-block mt-1">{fieldState.error.message}</small>
                  )}
                </>
              )}
            />
            {/* El monto es opcional aunque el operador cobre contra entrega: un pedido
                puede ir sin cobro. Dejarlo vacío = no se cobra nada al destinatario. */}
            <small className="text-muted d-block mt-1">
              {t("Déjalo vacío si este pedido no se cobra al destinatario.")}
            </small>
          </div>
        )}
      </div>
    </div>
  );
}
